import { Box, Button, CircularProgress, DialogActions, DialogContent, Divider, Typography } from "@mui/material";
import { FieldValues, useForm, UseFormReturn } from "react-hook-form";
import { ServicePrescribedInputRef, ServicesPrescribedInput } from "./ServicesPrescribedInput";
import { useEffect, useRef } from "react";
import { useStore } from "../../../../store/store";
import { Close as CloseIcon, Save as SaveIcon } from "@mui/icons-material";
import { useFields } from "../../../../api/useFields";
import { useUser } from "../../../../api/useAuth";
import { ServicesPrescribedForm, TreatmentPrescription } from "../types";

type ServicesPrescribedDialogProps = {
	treatmentId: number;
	treatmentPrescription: TreatmentPrescription;
};
export const ServicesPrescribedDialog = ({ treatmentId, treatmentPrescription }: ServicesPrescribedDialogProps) => {
	const { appDialog } = useStore();
	const { formatedFields: fieldsTreatmentPrescription, status: statusFieldsTP } = useFields("treatment_prescription");
	const { formatedFields: fieldsServicesPrescribed, status: statusFieldsSP } = useFields("services_prescribed");
	const { data: user, status: statusUser } = useUser();

	type Form = {
		treatment: number;
		content: string;
		services_prescribed: Array<ServicesPrescribedForm>;
	};

	const entityForm = useForm<Form>({
		mode: "onChange",
		defaultValues: { treatment: treatmentId },
	});
	const { isSubmitting } = entityForm.formState;
	const formHandlerRef = useRef<ServicePrescribedInputRef>(null);
	const onSubmit = async (formData: any) => {
		await formHandlerRef.current?.submitFn(formData);
	};

	useEffect(() => {
		if (treatmentPrescription?.services_prescribed.length === 0) return;

		entityForm.setValue(
			"services_prescribed",
			treatmentPrescription?.services_prescribed?.map((item) => {
				return {
					...item,
					service: { id: item?.service?.id, label: item?.service?.name },
					goals: item?.goals?.map((goal: any) => ({
						id: goal?.treatment_therapy_goals_id?.id,
						label: goal?.treatment_therapy_goals_id?.goal,
					})) || [],
				};
			})
		);
	}, [treatmentPrescription?.services_prescribed]);

	if (statusFieldsTP === "loading" || statusFieldsSP === "loading" || statusUser === "loading") {
		return <CircularProgress />;
	}
	if (statusFieldsTP === "error" || statusFieldsSP === "error" || statusUser === "error") {
		return <Typography>Erro ao carregar dados</Typography>;
	}
	if (!fieldsTreatmentPrescription || !fieldsServicesPrescribed || !user) {
		return <Typography>Erro ao carregar dados</Typography>;
	}

	return (
		<Box component={"form"} onSubmit={entityForm.handleSubmit(onSubmit)}>
			<DialogContent>
				<Divider sx={{ mb: 4 }} />
				<ServicesPrescribedInput
					entityForm={entityForm as unknown as UseFormReturn<FieldValues>}
					ref={formHandlerRef}
					treatmentPrescription={treatmentPrescription}
					fieldsTreatmentPrescription={fieldsTreatmentPrescription}
					fieldsServicesPrescribed={fieldsServicesPrescribed}
					user={user}
				/>
			</DialogContent>
			<DialogActions sx={{ padding: 4 }}>
				<Button disabled={isSubmitting} onClick={() => appDialog.toggleIsOpen()} color="secondary" startIcon={<CloseIcon />}>
					Cancelar
				</Button>
				<Button
					disabled={isSubmitting}
					type="submit"
					color="primary"
					variant="contained"
					startIcon={<SaveIcon />}
				>
					{isSubmitting ? "Guardar..." : "Guardar"}
				</Button>
			</DialogActions>
		</Box>
	);
};
